import { render } from "./NewPrintingProfile.vue?vue&type=template&id=40c1e17d"
import script from "./NewPrintingProfile.vue?vue&type=script&lang=js"
export * from "./NewPrintingProfile.vue?vue&type=script&lang=js"

import "./NewPrintingProfile.vue?vue&type=style&index=0&id=40c1e17d&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__